import { createReducer } from "./functions";

import {
  VISIT_SET_CURRENT_FILTERS,
  VISIT_SET_PAGINATION,
  VISIT_SET_FILTERS,
  VISIT_SET_VISITS,
  VISIT_SET_SORT,
  VISIT_SET_KEY_FILTER_SELECTED,
  VISIT_ADD_CURRENT_FILTERS
} from "./../types";

const initialState = {
  visits: [],
  page: 0,
  pages: 0,
  pageSize: 10,
  total: 0,
  hasNext: true,
  filters: null,
  currentFilters: {},
  sort: { startDate: -1 },
  keyFilterSelected: null
};

const setFilters = {
  [VISIT_SET_FILTERS]: (state, action) => {
    let newFilters = { ...state.filters };
    newFilters[action.key] = action.values;
    return { ...state, filters: newFilters };
  }
};

const setVisits = {
  [VISIT_SET_VISITS]: (state, action) => {
    const page = action.payload.hasOwnProperty("page") ? action.payload.page : state.page;
    const pages = action.payload.hasOwnProperty("pages") ? action.payload.pages : state.pages;
    const total = action.payload.hasOwnProperty("total") ? action.payload.total : state.total;
    let hasNext = true;
    if (page === 0 || page === pages) {
      hasNext = false;
    }
    return { ...state, visits: action.payload.docs, page, pages, hasNext, total };
  }
};

const setCurrentFilters = {
  [VISIT_SET_CURRENT_FILTERS]: (state, action) => {
    console.log("[SETCURRENT FILTER REDUCER", action);
    const currentFilters = { ...action.currentFilters };
    if (action.currentFilters.hasOwnProperty("period")) {
      currentFilters.startDate = {
        $gte: { $date: action.currentFilters.period.startDate }
      };
      currentFilters.endDate = {
        $lte: { $date: action.currentFilters.period.endDate }
      };
      delete currentFilters["period"];
    }
    console.log("[END REDUCER]", currentFilters);
    return Object.assign({}, state, {
      currentFilters: currentFilters
    });
  }
};

const setSort = {
  [VISIT_SET_SORT]: (state, action) => {
    console.log(action);
    console.log("[SETSORTREDUCER", action);

    return {
      ...state,
      sort: { [action.column]: action.sortOrder }
    };
  }
};
const setPagination = {
  [VISIT_SET_PAGINATION]: (state, action) => {
    return Object.assign({}, state, { page: action.page, pages: action.pages });
  }
};

const setKeyFilterSelected = {
  [VISIT_SET_KEY_FILTER_SELECTED]: (state, action) => {
    return { ...state, keyFilterSelected: action.key };
  }
};

const addCurrentFilter = {
  [VISIT_ADD_CURRENT_FILTERS]: (state, action) => {
    console.log("[ADDCURRENTFILTERSREDUCER", action);
    const currentFilters = state.currentFilters || {};
    currentFilters[action.key] = action.filters;
    return Object.assign({}, state, { currentFilters: currentFilters });
  }
};

const visitReducer = createReducer(initialState, {
  ...setCurrentFilters,
  ...addCurrentFilter,
  ...setPagination,
  ...setFilters,
  ...setVisits,
  ...setSort,
  ...setKeyFilterSelected
});

export default visitReducer;



// WEBPACK FOOTER //
// src/redux/reducers/visitReducer.js